export const KEYS = {
  ALT: 'Alt / ⌥',
  CTRL: 'Ctrl',
  MOD: '⌘',
  SHIFT: 'Shift',
  SLASH: '/',
  UP: 'Up',
  DOWN: 'Down',
};

export const SHORTCUT_KEYS = [
  {
    id: 1,
    label: 'OPEN_CONVERSATION',
    displayKeys: [KEYS.ALT, 'J', KEYS.SLASH, KEYS.ALT, 'K'],
    keySet: ['Alt+KeyJ', 'Alt+KeyK'],
  },
  {
    id: 2,
    label: 'RESOLVE_AND_NEXT',
    displayKeys: [KEYS.ALT, 'W', KEYS.SLASH, KEYS.MOD, KEYS.ALT, 'E'],
    keySet: ['Alt+KeyW', '$mod+Alt+KeyE'],
  },
  {
    id: 3,
    label: 'NAVIGATE_DROPDOWN',
    displayKeys: [KEYS.UP, KEYS.SLASH, KEYS.DOWN],
    keySet: ['ArrowUp', 'ArrowDown'],
  },
  {
    id: 4,
    label: 'RESOLVE_CONVERSATION',
    displayKeys: [KEYS.ALT, 'E'],
    keySet: ['Alt+KeyE'],
  },
  {
    id: 5,
    label: 'GO_TO_CONVERSATION_DASHBOARD',
    displayKeys: [KEYS.ALT, 'C'],
    keySet: ['Alt+KeyC'],
  },
  {
    id: 6,
    label: 'ADD_ATTACHMENT',
    displayKeys: [KEYS.ALT, 'A', KEYS.SLASH, KEYS.MOD, KEYS.ALT, 'A'],
    keySet: ['Alt+KeyA', '$mod+Alt+KeyA'],
  },
  {
    id: 7,
    label: 'GO_TO_CONTACTS_DASHBOARD',
    displayKeys: [KEYS.ALT, 'V'],
    keySet: ['Alt+KeyV'],
  },
  {
    id: 8,
    label: 'TOGGLE_SIDEBAR',
    displayKeys: [KEYS.ALT, 'O'],
    keySet: ['Alt+KeyO'],
  },
  {
    id: 9,
    label: 'GO_TO_REPORTS_SIDEBAR',
    displayKeys: [KEYS.ALT, 'R'],
    keySet: ['Alt+KeyR'],
  },
  {
    id: 10,
    label: 'MOVE_TO_NEXT_TAB',
    displayKeys: [KEYS.ALT, 'N'],
    keySet: ['Alt+KeyN'],
  },
  {
    id: 11,
    label: 'GO_TO_SETTINGS',
    displayKeys: [KEYS.ALT, 'S'],
    keySet: ['Alt+KeyS'],
  },
  {
    id: 12,
    label: 'SWITCH_TO_PRIVATE_NOTE',
    displayKeys: [KEYS.ALT, 'P'],
    keySet: ['Alt+KeyP'],
  },
  {
    id: 13,
    label: 'SWITCH_TO_REPLY',
    displayKeys: [KEYS.ALT, 'L'],
    keySet: ['Alt+KeyL'],
  },
  {
    id: 14,
    label: 'TOGGLE_SNOOZE_DROPDOWN',
    displayKeys: [KEYS.ALT, 'M'],
    keySet: ['Alt+KeyM'],
  },
  {
    id: 15,
    label: 'AI_ASSIST_MENU',
    displayKeys: [
      KEYS.CTRL,
      KEYS.SHIFT,
      'A',
      KEYS.SLASH,
      KEYS.MOD,
      KEYS.SHIFT,
      'A',
    ],
    keySet: ['Control+Shift+KeyA', '$mod+Shift+KeyA'],
  },
  {
    id: 16,
    label: 'AI_ASSIST_GRAMMAR',
    displayKeys: [
      KEYS.CTRL,
      KEYS.SHIFT,
      'G',
      KEYS.SLASH,
      KEYS.MOD,
      KEYS.SHIFT,
      'G',
    ],
    keySet: ['Control+Shift+KeyG', '$mod+Shift+KeyG'],
  },
  {
    id: 17,
    label: 'AI_ASSIST_UNIFY_LANG',
    displayKeys: [
      KEYS.CTRL,
      KEYS.SHIFT,
      'E',
      KEYS.SLASH,
      KEYS.MOD,
      KEYS.SHIFT,
      'E',
    ],
    keySet: ['Control+Shift+KeyE', '$mod+Shift+KeyE'],
  },
];

/**
 * Get keyboard shortcut keySet by label
 * @param {string} label - The label of the shortcut (e.g., 'AI_ASSIST_UNIFY_LANG')
 * @returns {Array<string>|null} - The keySet array or null if not found
 */
export const getKeySetByLabel = label => {
  const shortcut = SHORTCUT_KEYS.find(item => item.label === label);
  return shortcut ? shortcut.keySet : null;
};

/**
 * Create keyboard events object from label and handler
 * If the keySet contains multiple shortcuts, creates a handler for each
 * @param {string} label - The label of the shortcut (e.g., 'AI_ASSIST_UNIFY_LANG')
 * @param {Object|Function} handler - The handler object or function to execute
 * @returns {Object} - Object with keyboard event keys and handlers
 * @example
 * const events = createKeyboardEventsFromLabel('AI_ASSIST_GRAMMAR', {
 *   action: () => console.log('Grammar check'),
 *   allowOnFocusedInput: true
 * });
 * // Returns: { 'Control+Shift+KeyG': { action: ..., allowOnFocusedInput: true } }
 */
export const createKeyboardEventsFromLabel = (label, handler) => {
  const keySet = getKeySetByLabel(label);
  if (!keySet) return {};

  const events = {};
  keySet.forEach(key => {
    events[key] = handler;
  });
  return events;
};
